import { AmbassadorFileDTO } from '../models/ambassador-file-dto';
import { environment } from '../../environments/environment';

/**
 * Configuración de templates locales para desarrollo
 * Los templates están en public/development-templates/
 */
export class LocalTemplatesConfig {
  private static readonly BASE_URL = environment.urlApp + 'development-templates';
  private static readonly CSS_FILE_NAME = 'template-styles.css';

  /**
   * Obtiene el archivo CSS común para todos los templates
   */
  static getCommonCssFile(): AmbassadorFileDTO {
    return {
      IdFile: 'local-css-common',
      FileName: this.CSS_FILE_NAME,
      FileSize: 0,
      FileExtension: 'css',
      BlobContainer: 'ambassador-css',
      BlobFolder: 'common',
      BlobFileName: this.CSS_FILE_NAME,
      IsPublic: true,
      FileUri: `${this.BASE_URL}/${this.CSS_FILE_NAME}`
    };
  }

  /**
   * Crea un archivo DTO para un template HTML específico
   * @param templateName Nombre del archivo template (ej: 'login-template.html')
   * @param folder Carpeta donde está el template (opcional, por defecto '')
   */
  static getHtmlTemplate(templateName: string, folder: string = ''): AmbassadorFileDTO {
    const filePath = folder ? `${folder}/${templateName}` : templateName;
    return {
      IdFile: `local-html-${templateName.replace('.html', '')}`,
      FileName: templateName,
      FileSize: 0,
      FileExtension: 'html',
      BlobContainer: 'ambassador-html',
      BlobFolder: folder || 'templates',
      BlobFileName: templateName,
      IsPublic: true,
      FileUri: `${this.BASE_URL}/${filePath}`
    };
  }

  /**
   * Obtiene la URL base de los templates locales
   */
  static getBaseUrl(): string {
    return this.BASE_URL;
  }
}

